import React, { useState } from "react";
import { ProgressBar, Step } from "react-step-progress-bar";
import "react-step-progress-bar/styles.css";
import "../../style/component/level.css";
import CompleteLevel from "../../assets/image/completeLevel.png";
import InCompleteLevel from "../../assets/image/InCompleteLevel.png";
import aerrowUp from "../../assets/image/arrowUp.svg";
import levelContent from "../../assets/image/levelContent.svg";
import coin from "../../assets/image/coinBlack.svg";
import aerrowDown from "../../assets/image/arrowDown.svg";
import ProfileImage from "../../assets/image/select-quiz-img-3.png";

const LevelItem = ({ item }) => (
  <div className="d-flex align-items-start ">
    <div className="round"></div>
    <div className="level-item">
      <div className="description d-flex">
        <img src={coin} alt="Coin" />
        <div>{item}</div>
      </div>
      {/* <div className="date">{item.date}</div> */}
    </div>
  </div>
);

const Levels = ({ level, items, completed, expanded, onToggle }) => {
  // const [expanded, setExpanded] = useState(false);

  const levelNumber = level.match(/\d+/)?.[0];
  return (
    <div className={`level ${expanded ? "expanded" : ""}`}>
      <div
        className="level-header"
        onClick={onToggle}
        //  onClick={() => setExpanded(!expanded)}
      >
        <div className={`level-icon ${completed ? "completed" : ""}`}>
          <img src={CompleteLevel} alt="Level" />
          <span>{levelNumber}</span>
        </div>
        <div className="level-title">
          {" "}
          {level?.charAt(0).toUpperCase() + level?.slice(1)}
        </div>
        <div className="expand-icon">
          <img src={expanded ? aerrowUp : aerrowDown} alt="Arrow" />
        </div>
      </div>
      {expanded && (
        <div className="level-content">
          {/* <img src={levelContent} alt="Level Content"/> */}
          <div className="level-main">
            {items.length > 0 ? (
              items.map((item, index) => (
                <div key={index} item={item}>
                  <div className="d-flex align-items-start ">
                    <div className="round"></div>
                    <img src={coin} alt="Coin" className="item-coin" />
                    <div className="level-item">
                      <div className="description d-flex">
                        <div style={{ textWrap: "wrap" }}>{item}</div>
                      </div>
                      {/* <div className="date">{item.date}</div> */}
                    </div>
                  </div>
                </div>
              ))
            ) : (
              <div className="no-items">No items</div>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

const Level = ({ levelsData }) => {
  const [expandedIndex, setExpandedIndex] = useState(null);
  const containerRef = React.useRef(null);
  const [lineHeight, setLineHeight] = useState(0);
  const [completeHeight, setCompleteHeight] = useState(0);

  React.useEffect(() => {
    if (containerRef.current) {
      const container = containerRef.current;
      const levelElements = container.querySelectorAll('.level');
      
      if (levelElements.length > 0) {
        // Total line height goes from the first level to the last level
        const firstLevel = levelElements[0];
        const lastLevel = levelElements[levelElements.length - 1];
        const newTotalHeight = lastLevel.offsetTop + 50; // approximate center of last icon
        setLineHeight(newTotalHeight);

        // Calculate complete height
        let lastCompletedIndex = -1;
        levelsData?.forEach((level, index) => {
          if (level?.is_completed) {
            lastCompletedIndex = index;
          }
        });

        if (lastCompletedIndex === -1) {
          setCompleteHeight(0);
        } else if (lastCompletedIndex === levelsData.length - 1) {
          setCompleteHeight(newTotalHeight);
        } else {
          const nextLevel = levelElements[lastCompletedIndex + 1];
          if (nextLevel) {
            setCompleteHeight(nextLevel.offsetTop + 50);
          }
        }
      }
    }
  }, [expandedIndex, levelsData]);

  const handleToggle = (index) => {
    setExpandedIndex((prev) => (prev === index ? null : index));
  };

  return (
    <div className="app">
      <div className="main-title">My Levels</div>
      {levelsData?.length === 0 ? (
        <div className="progress-bar pt-0">
          <h5 className="" style={{ marginTop: "66%" }}>No Levels</h5>
        </div>
      ) : (
        <div className="progress-bar" ref={containerRef}>
          <div
            className="progress-bar-line"
            style={{ height: `${lineHeight}px` }}
          >
            <div
              className="progress-bar-complete"
              style={{
                height: `${completeHeight}px`,
              }}
            ></div>
          </div>
          {levelsData?.map((levelData, index) => (
            <Levels
              key={index}
              level={levelData?.name}
              items={levelData?.achievement}
              completed={levelData?.is_completed}
              expanded={expandedIndex === index}
              onToggle={() => handleToggle(index)}
            />
          ))}
        </div>
      )}
    </div>
  );
};

export default Level;

// const Level = () => {

//     const [percent, setPercent] = useState(55);

//     const increaseProgress = () => {
//         setPercent(prev => (prev < 100 ? prev + 10 : 100));
//     };

//     const decreaseProgress = () => {
//         setPercent(prev => (prev > 0 ? prev - 10 : 0));
//     };

//     const getHexagonImage = (index) => {
//         if (percent >= 10 && index === 0) {
//             return CompleteLevel;
//         } else if (percent >= 30 && index === 1) {
//             return CompleteLevel;
//         } else if (percent >= 65 && index === 2) {
//             return CompleteLevel;
//         } else {
//             return InCompleteLevel;
//         }
//     };

//     return (
//         <div className="level-main-container">
//             <div className="progress-container">
//                 <ProgressBar
//                     percent={percent}
//                     filledBackground="linear-gradient(to right, #66ff99, #33cc66)"
//                     stepPositions={[0, 30, 70]} // Adjust these values based on your needs
//                 >
//                     {[8, 9, 10].map((level, index) => (
//                         <Step key={index} transition="scale">
//                             {({ accomplished }) => (
//                                 <div className={`step ${accomplished ? 'completed' : ''}`}>
//                                     <div className="hexagon">
//                                         <img src={getHexagonImage(index)} alt={`Level ${level}`} />
//                                         <span>{level} Level</span>
//                                     </div>
//                                 </div>
//                             )}
//                         </Step>
//                     ))}
//                 </ProgressBar>
//                 <div className="percentage-display" style={{ left: `${percent}%` }}>

//                         <img src={ProfileImage} className=""/>
//                     </div>

//             </div>
//             <div className="progress-buttons">
//                     <button className='btn btn-outline-success text-white ' onClick={decreaseProgress}>Decrease</button>
//                     <button className='btn btn-outline-success text-white' onClick={increaseProgress}>Increase</button>
//                 </div>
//         </div>
//     );
// };
